<template>
  <v-container fluid :style="{height:'100%', 'background-color':pageElements[$route.name].color}">
    <v-layout row wrap v-if="commentsData">
      <v-flex xs12 sm8>
        <v-card height="100%" :color="backgroundColor" depressed>
          <v-card-text>
            <div v-show="!ready" class="text-xs-center" style="height:300px">
              <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
            </div>
            <v-select
              id="videoSelector"
              v-show="ready"
              solo-inverted
              v-model="video"
              background-color="#719bee"
              color="#719bee"
              item-value="id"
              item-text="title"
              :items="videos"
              @input="videoChanged"
              label="Video"
            ></v-select>

            <TwitchPlayer
              id="twitchPlayer"
              v-show="ready"
              @pause="videoPaused"
              @playing="videoPlaying"
              @ready="videoReady"
	      :video="video"
              :key="video"
              :seekTime="seekTime"
            />
          </v-card-text>

          <!-- 401013830 -->
          <!-- 404625922 -->
          <!-- 404625922 -->
          <v-card-text>
            <div text-xs-right>
              <v-tour name="twitchTour" :steps="steps">
                <template slot-scope="tour">
                  <transition name="fade">
                    <v-step
                      v-if="tour.currentStep === index"
                      v-for="(step, index) of tour.steps"
                      :key="index"
                      :step="step"
                      :previous-step="tour.previousStep"
                      :next-step="tour.nextStep"
                      :stop="tour.stop"
                      :is-first="tour.isFirst"
                      :is-last="tour.isLast"
                      :labels="tour.labels"
                    >
                      <!-- <template v-if="tour.currentStep === 2">
                        <div slot="actions">
                          <v-btn @click="tour.previousStep" color="primary">Previous step</v-btn>
                          <v-btn @click="tour.nextStep" color="primary">Next step</v-btn>
                        </div>
                      </template>-->
                    </v-step>
                  </transition>
                </template>
              </v-tour>

              <AnalysisChart
                id="analysisChart"
                @click="chartClicked"
                :commentsData="commentsData"
                class="small"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 text-xs-left>
        <v-card height="100%" :color="backgroundColor" depressed>
          <TwitchChat
            id="twitchChat"
            :commentsData="commentsData"
            :paused="paused"
            :videoTime="videoTime"
          />
        </v-card>
      </v-flex>
    </v-layout>
    <div v-else class="text-xs-center" style="height:300px;margin:20%">
      <v-progress-circular :size="200" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import TwitchPlayer from "@/components/videochat/TwitchPlayer";
import TwitchChat from "@/components/videochat/TwitchChat";
import AnalysisChart from "@/components/videochat/AnalysisChart";
// import commentsData from "@/401013830_classified.json";
// import commentsData from "@/404625922_classified.json";
// import commentsData from "@/404625922_classified.json";
import { mapGetters, mapActions } from "vuex";
require("vue-tour/dist/vue-tour.css");

export default {
  data() {
    return {
      video: "470672116",
      backgroundColor: "#182952",
      watchedTwitchDemo: false,
      commentsData: null,
      seekTime: null,
      videoTime: null,
      paused: false,
      ready: false,
      steps: [
        {
          target: "#twitchPlayer",
          content:
            "In this demo, you can watch a Twitch video and see the level of hate, toxicity, or certain emotions at different video moments."
        },
        {
          target: "#videoSelector",
          content: "You can choose one of the videos from this dropdown."
        },
        {
          target: "#analysisChart",
          content:
            "Simply click on the dots in the chart to navigate to the time in the video and chat associated with that dot.",
          params: {
            placement: "top"
          }
        },
        {
          target: "#analysisChart",
          content:
            "The percentage values represent the likelihood per aspect (e.g. Hate/Anger) in the chat in each interval of 50 seconds.",
          params: {
            placement: "top"
          }
        },
        {
          target: "#twitchChat",
          content:
            "You can view the chat synchronized with the video. Comments labeled as 'hate' will be surrounded by two 🤬 emojis. "
        }
      ]
    };
  },
  methods: {
    ...mapActions("gaming", {
      fetchVideoAnalysis: "fetchVideoAnalysis"
    }),
    chartClicked(time) {
      this.seekTime = time;
    },
    videoChanged() {
      console.log(this.video);
    },

    videoPlaying(time) {
      if (!this.ready) {
        this.ready = true;
        if (!this.watchedTwitchDemo) {
          this.watchedTwitchDemo = true;
          this.startTour();
        }
      }

      //   if (this.paused || this.videoTime === null) {
      this.paused = false;
      console.log(time);
      this.videoTime = time;
      //   }
    },
    videoPaused() {
      this.paused = true;
    },
    videoReady() {
      if (!this.ready) {
        this.ready = true;
      }
    } 
  },
  components: {
    TwitchPlayer,
    TwitchChat,
    AnalysisChart
  },
  computed: {
    ...mapGetters("common", {
      pageElements: "pageElements"
    }),
    videos() {
      return [
        { id: "470672116", title: "Video 1" }
        // { id: "401013830", title: "Video 2" },
        // { id: "402025404", title: "Video 3" }
      ];
    }
  },
  mounted() {
    console.log(localStorage.watchedTwitchDemo);
    if (localStorage.watchedTwitchDemo) {
      this.watchedTwitchDemo = true;
    }
    let self = this;
    this.fetchVideoAnalysis({ videoId: this.video }).then(function(results) {
      self.commentsData = results;
    });
  },
  watch: {
    watchedTwitchDemo(newVal) {
      localStorage.watchedTwitchDemo = newVal;
    }
  }
};
</script>

<style scoped>
.small {
  /* max-width: 600px; */
  width: 100%;
}
.Chart {
  background: #212733;
  border-radius: 15px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  margin: 25px 0;
  max-width: 600px;
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color: rgba(255, 0, 0, 0.5);
  border-bottom: 1px solid #bbbdc2;
}
</style>
